import React, { useCallback, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import Chat from '../components/user/Chat/Chat';
import Authenticated from '../middlewares/Authenticated';
import VerifiedMember from '../middlewares/VerifiedMember';
import CompleteSetup from '../middlewares/CompleteSetup';

import Navbar from '../components/user/Navbar';
import Notifications from '../components/user/Notifications';
import useAuthStore from '../store/auth';
import io from 'socket.io-client';
import Cookies from 'js-cookie';
import config from '../config';

import 'animate.css';
import { refresh, signOut } from '../adapters/authentication';
import { myProfile } from '../adapters/profle';



export default function DashboardLayout() {
    const socket = io(config.SERVER_URL);

    const navigate = useNavigate();
    const user = useAuthStore((state) => state.user);
    const token = useAuthStore((state) => state.token);
    
    const clearAuth = useAuthStore((state) => state.clearAuth);
    const setAuth = useAuthStore((state) => state.setAuth);
    
    useEffect(() => {
         myProfile().then((res) => {
            setAuth({ user: res.data}); 
        })
    }, [setAuth])

    useEffect(() => {
        socket.on('connect', (message) => {
            socket.emit('handshake', user._id);
        });
        return () => {
            socket.disconnect();
        };
    }, [user, socket]);
    
    
    useEffect(() => {
        if (!user.verified) {
            return navigate('/email-verification');
        } else if (!user.initSetup) {
            return navigate('/account/initial-setting');
        }
    }, [user, navigate]);
    


    const [showChatPane, setShowChatPane ] = useState(false);
    const [showNotificationPane, setShowNotificationPane] = useState(false);


    const refreshToken = () => {
        refresh(token).then((res) => {
            setAuth({ user: res.data.user}); 
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getProfile = () => {
       
    }

    const logout = () => {
        clearAuth();
        signOut();
        Cookies.remove('auth:token')
        navigate("/auth/sign-in", { replace: true });
    }


    return (
        <Authenticated>
            <VerifiedMember>
                <CompleteSetup>
                    <div>
                        <Navbar socket={socket} logout={logout} chatIconHandler={() => setShowChatPane(!showChatPane)} notifyIconHandler={() => setShowNotificationPane(!showNotificationPane)} user={user} />
                        <div className="relative">
                            {showChatPane && <Chat user={user} socket={socket} onClose={() => setShowChatPane(false)} />}
                            {showNotificationPane  && <Notifications socket={socket} onClose={() => setShowNotificationPane(!showNotificationPane)} user={user} />}
                            <Outlet context={{ user, logout, token, refreshToken, socket } } />
                        </div>
                    </div>
                </CompleteSetup>
            </VerifiedMember>
        </Authenticated>
    )
}
